import React, { useMemo, useState, useEffect } from "react";
import MaterialReactTable from "material-react-table";
import axios from "axios";

const IndicadorGrupoA1 = ({ id }) => {
  // ✅ 1. Columnas optimizadas (solo esenciales primero)
  const columns = useMemo(
    () => [
      { accessorKey: "id", header: "Id", size: 80 },
      { accessorKey: "nombreIndicador", header: "Nombre del Indicador" },
      { accessorKey: "codigo", header: "Código Único" },
      { accessorKey: "nivelDesagregacion", header: "Nivel" },
      { accessorKey: "unidadMedicion", header: "Unidad" },
      { accessorKey: "resultado", header: "Resultado" },
      { accessorKey: "mesCorte", header: "Mes" },
      { accessorKey: "sede", header: "Sede" },
    ],
    [],
  );

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!id) return;

    const controller = new AbortController(); // ✅ cancela petición

    const cargarDatos = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await axios.get(
          `https://suadesarrollo.azurewebsites.net/api/QIndicadorAyBInstitucionId?InstitucionId=${id}&grupo=A1`, // SI PUEDES FILTRAR EN BACK MEJOR
          {
            auth: {
              username: "BasicAuth@icontec.org",
              password: "yQLzqmR7eZSuAmQZUqhY",
            },
            signal: controller.signal,
            timeout: 15000,
          },
        );

        const datos = Array.isArray(response.data)
          ? response.data
          : response.data?.data || [];

        // ✅ FILTRO AQUÍ (mucho más rápido que useMemo)
        const filtrados = datos.filter((item) => item.grupo === "A1");

        // ✅ SI SON MUCHÍSIMOS, RECORTA PARA NO PETAR LA UI
        const MAX = 50000;
        setData(filtrados.slice(0, MAX));
      } catch (err) {
        if (!axios.isCancel(err)) {
          console.error(err);
          setError("Error al cargar datos");
        }
      } finally {
        setLoading(false);
      }
    };

    cargarDatos();

    return () => controller.abort();
  }, [id]);

  return (
    <div style={{ padding: "10px" }}>
      <h4>Indicadores del Grupo A1</h4>

      {loading && (
        <div style={{ textAlign: "center", padding: "30px" }}>
          <div className="spinner-border text-primary" role="status" />
          <p>Cargando indicadores...</p>
        </div>
      )}

      {!loading && data.length === 0 && !error && (
        <h5 style={{ color: "red", textAlign: "center" }}>
          No se encontraron registros del grupo A1
        </h5>
      )}

      {error && <p style={{ color: "red" }}>{error}</p>}

      {!loading && data.length > 0 && (
        <MaterialReactTable
          columns={columns}
          data={data}
          // ⚡ RENDIMIENTO EXTREMO
          enableRowVirtualization
          enablePagination={false}
          enableBottomToolbar={false}
          enableColumnResizing
          enableGlobalFilter
          columnResizeMode="onChange"
          layoutMode="grid"
          muiTableContainerProps={{
            sx: { maxHeight: "75vh" },
          }}
        />
      )}
    </div>
  );
};

export default IndicadorGrupoA1;
